import React, { useContext, useReducer } from 'react'
import { t } from 'i18next';
import { logout } from '../../services/login';
import { createAreaService, deleteAreasService, editAreaService, getListOfAreasService, getSettingMenuService, setSettingService } from '../../services/Settings';
import { getTenantInfoByKey } from '../../helpers/helpers';
import InstanceContext from '../InstanceContext/InstanceContext';
import AreasManagementContext from './AreasManagementContext';
import AreasManagementReducer from './AreasManagementReducer';
import { CLEAN_AREAS_ERROR, CLEAN_AREAS_STATE, CRUD_AREAS, GET_AREAS, SET_AREA_DATA } from './types';

const AreasManagementState = ({ children }) => {
    const openingName = getTenantInfoByKey('opening_name');
    const nameOfAreas = getTenantInfoByKey('area_name');

    const { instanceInfoGet } = useContext(InstanceContext);

    const initialState = {
        areasToConfig: [],
        areaData: {
            areaCode: '',
            areaDescription: '',
            areaEnabled: 1,
            buildingId: null
        },
        isFetching: false,
        error: {
            ok: false,
            text: ''
        },
        responseAreaService: {
            show: false,
            type: '',
            text: '',
        }
    }

    const [state, dispatch] = useReducer(AreasManagementReducer, initialState);

    const setFetching = (value) => {
        dispatch({
            type: 'SET_FETECHING',
            payload: value
        });
    }

    const getAreasManagement = async (text) => {
        try {
            setFetching(true);
            const param = text ? `searchText=${text}` : null
            const items = await getListOfAreasService(param);

            items.data.response.forEach(element => {
                element.buildingId = element.Building ? element.Building.buildingId : null;
            });

            if (items.ok) {
                dispatch({
                    type: GET_AREAS,
                    payload: {
                        areasToConfig: items.data.response,
                        responseAreaService: {
                            show: false,
                            type: 'SUCCESS',
                            text: '',
                        }
                    }
                })
            } else {

                let errorMsg;
                switch (items.data.error_code) {
                    case 'PARAM_ERROR':
                        errorMsg = t('ERROR_TRY_AGAIN');
                        break;
                    case 'PROFILE_ACCESS_ERROR':
                        errorMsg = t('PERMISSIONS_ERROR');
                        setTimeout(() => {
                            logout();
                        }, 1000);
                        break;
                    case 'AUTH_ERROR':
                        errorMsg = t('TOKEN_ERROR');
                        setTimeout(() => {
                            logout();
                        }, 1000);
                        break;
                    default:
                        errorMsg = t('ERROR_TRY_AGAIN');
                        break;
                }

                dispatch({
                    type: GET_AREAS,
                    payload: {
                        areasToConfig: state.areasToConfig,
                        responseAreaService: {
                            show: true,
                            type: 'ERROR',
                            text: errorMsg,
                        }
                    }
                })
            }
        } catch (e) {
            console.log(e)
            dispatch({
                type: GET_AREAS,
                payload: {
                    resources: state.areasToConfig,
                    responseAreaService: {
                        show: true,
                        type: 'ERROR',
                        text: t('SERVER_ERROR'),
                    }
                }
            });
        }
    }

    const getArea = async (id) => {
        try {
            setFetching(true);
            const param = id ? `areaId=${id}` : null
            const items = await getListOfAreasService(param);

            const element = items.data.response[0];
            element.buildingId = element.Building ? element.Building.buildingId : null;

            if (items.ok) {
                setAreaData(items)
                return element;
            } else {

                let errorMsg;
                switch (items.data.error_code) {
                    case 'PARAM_ERROR':
                        errorMsg = t('ERROR_TRY_AGAIN');
                        break;
                    case 'PROFILE_ACCESS_ERROR':
                        errorMsg = t('PERMISSIONS_ERROR');
                        setTimeout(() => {
                            logout();
                        }, 1000);
                        break;
                    case 'AUTH_ERROR':
                        errorMsg = t('TOKEN_ERROR');
                        setTimeout(() => {
                            logout();
                        }, 1000);
                        break;
                    default:
                        errorMsg = t('ERROR_TRY_AGAIN');
                        break;
                }

                dispatch({
                    type: GET_AREAS,
                    payload: {
                        areasToConfig: state.areasToConfig,
                        responseAreaService: {
                            show: true,
                            type: 'ERROR',
                            text: errorMsg,
                        }
                    }
                })
            }
        } catch (e) {
            console.log(e)
            dispatch({
                type: GET_AREAS,
                payload: {
                    resources: state.areasToConfig,
                    responseAreaService: {
                        show: true,
                        type: 'ERROR',
                        text: t('SERVER_ERROR'),
                    }
                }
            });
        }
    }

    const createArea = async (area) => {
        try {
            setFetching(true);

            area.areaEnabled = area.areaEnabled ? 1 : 0;
            const items = await createAreaService(area);

            if (items.ok) {
                dispatch({
                    type: CRUD_AREAS,
                    payload: {
                        responseAreaService: {
                            show: true,
                            type: 'SUCCESS',
                            text: `${nameOfAreas} ${t('CREATED_SUCCESSFULLY')}`,
                        }
                    }
                })
                instanceInfoGet();
            } else {

                let errorMsg;
                switch (items.data.error_code) {
                    case 'PARAM_ERROR':
                        errorMsg = t('CODE_ALREADY_EXIST');
                        break;
                    case 'NOT_ACCESS_OPENING':
                        errorMsg = `${openingName} ${t('NOT_ACCESS_OPENING')}`;
                        break;
                    case 'PROFILE_ACCESS_ERROR':
                        errorMsg = t('PERMISSIONS_ERROR');
                        setTimeout(() => {
                            logout();
                        }, 1000);
                        break;
                    case 'AUTH_ERROR':
                        errorMsg = t('TOKEN_ERROR');
                        setTimeout(() => {
                            logout();
                        }, 1000);
                        break;
                    default:
                        errorMsg = t('ERROR_TRY_AGAIN');
                        break;
                }

                dispatch({
                    type: CRUD_AREAS,
                    payload: {
                        responseAreaService: {
                            show: true,
                            type: 'ERROR',
                            text: errorMsg
                        },
                    }
                })
            }
        } catch (e) {
            console.log(e)
            dispatch({
                type: CRUD_AREAS,
                payload: {
                    responseAreaService: {
                        show: true,
                        type: 'ERROR',
                        text: t('SERVER_ERROR')
                    },
                }
            });
        }
    }

    const editArea = async (area) => {
        try {
            setFetching(true);

            area.enabled = area.enabled ? 1 : 0;
            const items = await editAreaService(area);

            if (items.ok) {
                dispatch({
                    type: CRUD_AREAS,
                    payload: {
                        responseAreaService: {
                            show: true,
                            type: 'SUCCESS',
                            text: `${nameOfAreas} ${t('EDITED_SUCCESSFULLY')}`,
                        }
                    }
                })
            } else {

                let errorMsg;
                switch (items.data.error_code) {
                    case 'PARAM_ERROR':
                        errorMsg = t('ERROR_TRY_AGAIN');
                        break;
                    case 'RESOURCES_IN_AREA':
                        errorMsg = t('CANT_ENABLE_FOR_ENTRYS');
                        break;
                    case 'PROFILE_ACCESS_ERROR':
                        errorMsg = t('PERMISSIONS_ERROR');
                        setTimeout(() => {
                            logout();
                        }, 1000);
                        break;
                    case 'AUTH_ERROR':
                        errorMsg = t('TOKEN_ERROR');
                        setTimeout(() => {
                            logout();
                        }, 1000);
                        break;
                    default:
                        errorMsg = t('ERROR_TRY_AGAIN');
                        break;
                }

                dispatch({
                    type: CRUD_AREAS,
                    payload: {
                        responseAreaService: {
                            show: true,
                            type: 'SUCCESS',
                            text: errorMsg,
                        }
                    }
                })
            }
        } catch (e) {
            console.log(e)
            dispatch({
                type: CRUD_AREAS,
                payload: {
                    responseAreaService: {
                        show: true,
                        type: 'SUCCESS',
                        text: t('SERVER_ERROR'),
                    }
                }
            });
        }
    }

    const deleteArea = async (query) => {
        try {
            setFetching(true);

            const items = await deleteAreasService(query);

            if (items.ok) {
                dispatch({
                    type: CRUD_AREAS,
                    payload: {
                        responseAreaService: {
                            show: true,
                            type: 'SUCCESS',
                            text: `${nameOfAreas} ${t('DELETED_SUCCESSFULLY')}`,
                        }
                    }
                })

            } else {

                let errorMsg;
                switch (items.data.error_code) {
                    case 'PARAM_ERROR':
                        errorMsg = t('CANT_DELETE_FOR_ENTRYS');
                        break;
                    case 'PROFILE_ACCESS_ERROR':
                        errorMsg = t('PERMISSIONS_ERROR');
                        setTimeout(() => {
                            logout();
                        }, 1000);
                        break;
                    case 'AUTH_ERROR':
                        errorMsg = t('TOKEN_ERROR');
                        setTimeout(() => {
                            logout();
                        }, 1000);
                        break;
                    default:
                        errorMsg = t('ERROR_TRY_AGAIN');
                        break;
                }

                dispatch({
                    type: CRUD_AREAS,
                    payload: {
                        responseAreaService: {
                            show: true,
                            type: 'SUCCESS',
                            text: errorMsg,
                        }
                    }
                })
            }
        } catch (e) {
            console.log(e)
            dispatch({
                type: CRUD_AREAS,
                payload: {
                    responseAreaService: {
                        show: true,
                        type: 'SUCCESS',
                        text: t('SERVER_ERROR'),
                    }
                }
            });
        }
    }

    const cleanAreaState = () => {
        dispatch({
            type: CLEAN_AREAS_STATE,
        });
    }

    const removeWarningModal = (type) => {
        dispatch({
            type: CLEAN_AREAS_ERROR,
        });
    }

    const setAreaData = (area) => {
        dispatch({
            type: SET_AREA_DATA,
            payload: area
        });
    }

    const changeNameOfAreas = async (value) => {
        try {
            setFetching(true);

            const items = await setSettingService(value);

            if (items.ok) {
                const textSuccess = t('EDITED_SUCCESSFULLY')
                let textWithUpperCase = textSuccess.charAt(0).toUpperCase() + textSuccess.slice(1);
                dispatch({
                    type: CRUD_AREAS,
                    payload: {
                        responseAreaService: {
                            show: true,
                            type: 'SUCCESS',
                            text: textWithUpperCase,
                        }
                    }
                })
                const menu = await getSettingMenuService();
                const tenantInfo = JSON.parse(localStorage.getItem('tenant'));
                tenantInfo.area_name = value.setting_value;
                localStorage.setItem('tenant', JSON.stringify(tenantInfo));
                localStorage.setItem('settingMenu', JSON.stringify(menu.data.response));
            } else {

                let errorMsg;
                switch (items.data.error_code) {
                    case 'PARAM_ERROR':
                        errorMsg = t('ERROR_TRY_AGAIN');
                        break;
                    case 'RESOURCES_IN_BUILDING':
                        errorMsg = t('ERROR_TRY_AGAIN');
                        break;
                    case 'PROFILE_ACCESS_ERROR':
                        errorMsg = t('PERMISSIONS_ERROR');
                        setTimeout(() => {
                            logout();
                        }, 1000);
                        break;
                    case 'AUTH_ERROR':
                        errorMsg = t('TOKEN_ERROR');
                        setTimeout(() => {
                            logout();
                        }, 1000);
                        break;
                    default:
                        errorMsg = t('ERROR_TRY_AGAIN');
                        break;
                }

                dispatch({
                    type: CRUD_AREAS,
                    payload: {
                        responseAreaService: {
                            show: true,
                            type: 'SUCCESS',
                            text: errorMsg,
                        }
                    }
                })
            }
        } catch (e) {
            console.log(e)
            dispatch({
                type: CRUD_AREAS,
                payload: {
                    responseAreaService: {
                        show: true,
                        type: 'SUCCESS',
                        text: t('SERVER_ERROR'),
                    }
                }
            });
        }
    }

    return (
        <AreasManagementContext.Provider
            value={{
                areasManagementState: state,
                getAreasManagement,
                deleteArea,
                createArea,
                cleanAreaState,
                removeWarningModal,
                setAreaData,
                editArea,
                changeNameOfAreas,
                getArea
            }}
        >
            {children}
        </AreasManagementContext.Provider>
    )
}

export default AreasManagementState